export default {
  onClick: (eventLabel: string) => ({
    event: 'loadEventData',
    eventCategory: 'CTA',
    eventAction: 'Linked Card',
    eventLabel,
    nonInteractive: false,
    customMetrics: {},
    customVariables: {},
    _clear: true
  })
}
